<template>
  <div class="component-two">
    <p>Component Two (should be blue)</p>
  </div>
</template>

<script>
export default {
  name: 'component-two'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  color: #000088;
}
</style>



// WEBPACK FOOTER //
// ComponentTwo.vue?1989bc63